import React from "react";
import {
  CAPTION,
  CIRCLE,
  HOMEPAGE,
  LOOKING,
  UPLOAD_DOC,
} from "../../../utils-func/image_exports";
import { Fade } from "react-awesome-reveal";

function Features() {
  return (
    <div
      id="features"
      className="flex items-center flex-col justify-center mt-4 lg:px-10 px-5"
    >
      <div className="flex flex-col items-center gap-y-5">
        <span className="lg:text-[56px] text-[30px] font-medium lg:leading-[60px] leading-[40px] text-center">
          Features that work <br /> for Your Litigation
        </span>
        <span className="lg:text-xl text-lg font-normal text-center">
          Check out our amazing features and <br /> experience AI yourself.
        </span>
      </div>
      <div className="mt-10 flex flex-col gap-y-5 lg:px-0 px-8">
        <div className="flex lg:flex-row flex-col gap-y-4 items-center gap-x-4">
          <Fade direction="left" duration={1000}>
            <Cards
              width="lg:w-[609.36px] w-full"
              para="Quickly access relevant cases and streamline your research with our robust search functionality."
              title="Advanced Search with History"
              bgImg={LOOKING}
              imgSize=""
            />
          </Fade>
          <Fade direction="right" duration={1500}>
            <Cards
              width="lg:w-[609.36px] w-full"
              para="Organize all your case documents in one secure place for easy access."
              title="Document Uploads"
              bgImg={UPLOAD_DOC}
              imgSize={""}
            />
          </Fade>
        </div>
        <div className="flex lg:flex-row flex-col gap-y-5 items-center gap-x-4">
          <Fade direction="left" duration={2000}>
            <Cards
              width="lg:w-[388px] w-full "
              para="Convert your spoken words into accurate text for effortless documentation."
              title="Speech-to-Text Capabilities"
              bgImg={CIRCLE}
              imgSize={"-right-3"}
            />
          </Fade>
          <Fade direction="right" duration={2500} className="w-full">
            <Cards
              width="w-full"
              para="Receive real-time captions during proceedings to ensure you never miss a detail."
              title="Live Captions"
              bgImg={CAPTION}
              imgSize={"w-[552.36px] h-[282.54px]"}
            />
          </Fade>
        </div>
        <Fade direction="left" duration={3000} className="lg:mt-o mt-5">
          <Cards
            width="w-full"
            para="Get tailored suggestions and comprehensive case analysis to support your decision-making."
            title="AI-Driven Insights"
            bgImg={HOMEPAGE}
            imgSize={"w-[760.44px] h-[491.56px] -bottom-[124px]"}
          />
        </Fade>
      </div>
    </div>
  );
}

export default Features;

export const Cards = ({
  width,
  bgImg,
  title,
  para,
  imgSize,
}: {
  width: string;
  bgImg: string | null;
  title: string;
  para: string;
  imgSize: string;
}) => {
  return (
    <div
      className={`h-[346.31px] relative ${
        width || "w-[400px]"
      } rounded-xl shadow `}
      style={{
        background:
          "linear-gradient(150.2deg, rgba(255, 255, 255, 0) 16.9%, #FFCC29 140.31%)",
      }}
    >
      <div className="flex items-start flex-col gap-y-4 w-[330.46px] p-5">
        <span className="text-[28.96px] font-bold text-black leading-tight">
          {title}
        </span>
        <p className="text-[19.31px] text-[#333333CC]">{para}</p>
      </div>
      {bgImg && (
        <img
          src={bgImg}
          className={` ${
            imgSize ||
            "lg:w-[359.97px] w-[200px] h-[261.55px] lg:top-[110px] top-[160px]"
          } object-contain absolute right-0 -bottom-5`}
          alt=""
        />
      )}
    </div>
  );
};
